import PropTypes from 'prop-types';
import { Loader } from 'ypf-pas-general-ui-components';

import './Loading.scss';

const Loading = ({ show }) => (
  <div className="loader">
    <Loader show={show} text="CARGANDO ..." />
  </div>
);

export default Loading;

Loading.propTypes = {
  show: PropTypes.bool,
};

Loading.defaultProps = {
  show: false,
};
